import mitt from 'mitt';

const emitter = mitt();

// Wrapper für Legacy-Kompatibilität
const EventBus = {
  on: emitter.on,
  off: emitter.off,
  emit: emitter.emit,
  // Legacy-API für alten Code
  $on: emitter.on,
  $off: emitter.off,
  $emit: emitter.emit,
};

export default EventBus;
